import { useTheme } from '@mui/material';
import { Cell, Pie, PieChart } from 'recharts';

export interface Data {
  name: string;
  value: number;
}

interface PieChartWhitoutLabelProps {
  data: Array<{ name: string; value: number | string; color: string }>;
}

const titles = ['En curso', 'Completados', 'En revisión'];

const Charts = ({ data }: PieChartWhitoutLabelProps) => {
  const theme = useTheme();
  const allZero = data.every((item) => item.value === 0);
  const filteredData = allZero
    ? [{ name: 'Group A', value: 1, color: '#12344A' }]
    : data.filter((item) => Number(item.value) > 0 && !titles.includes(item.name));

  return (
    <PieChart height={140} width={140}>
      <Pie
        data={filteredData}
        fill={'#9697af44'}
        labelLine={false}
        outerRadius={60}
        innerRadius={35}
        dataKey="value"
        cx="50%"
        cy="50%"
      >
        {filteredData.map((data, index) => (
          <Cell key={`cell-${index}`} fill={allZero ? theme.palette.secondary.main : data.color} />
        ))}
      </Pie>
    </PieChart>
  );
};

export default Charts;
